"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processApolloError = exports.defaultErrorMessageTranslations = exports.isGraphQLError = exports.isApolloError = void 0;
const types_1 = require("./types");
function isApolloError(error) {
    return error.graphQLErrors !== undefined;
}
exports.isApolloError = isApolloError;
function isGraphQLError(error) {
    return error.extensions !== undefined;
}
exports.isGraphQLError = isGraphQLError;
function normalizeErrorMessage(message) {
    if (typeof message === 'object') {
        if (message.error != null) {
            return message.error;
        }
        return 'Unknown error: ' + JSON.stringify(message);
    }
    return message;
}
function normalizeError(error) {
    if (isGraphQLError(error)) {
        return {
            ...error,
            message: normalizeErrorMessage(error.message),
        };
    }
    return error;
}
function translateErrorMessage(messageOrCode, translations) {
    var _a;
    return (_a = translations[messageOrCode]) !== null && _a !== void 0 ? _a : messageOrCode;
}
exports.defaultErrorMessageTranslations = {
    FAILED_TO_FETCH: 'Unable to communicate with server. The service may be down or you may be offline. Try again in a moment.',
    INTERNAL_SERVER_ERROR: `A server error has occurred.`,
};
const defaultProcessorOptions = {
    isUnauthorizedError: (error) => {
        var _a, _b, _c;
        return error.message === 'Unauthorized' ||
            ((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'FORBIDDEN' ||
            ((_c = (_b = error.extensions) === null || _b === void 0 ? void 0 : _b.exception) === null || _c === void 0 ? void 0 : _c.status) === 401;
    },
    translations: exports.defaultErrorMessageTranslations,
};
function processGraphQLError(error, options = {}) {
    var _a, _b;
    options = { ...defaultProcessorOptions, ...options };
    const { isUnauthorizedError, onUnauthorizedError, onInputValidationError, onServerError, translations } = options;
    if (isUnauthorizedError != null && isUnauthorizedError(error)) {
        const processedError = {
            type: types_1.ApolloErrorType.UNAUTHORIZED_ERROR,
            error: normalizeError(error),
            message: normalizeErrorMessage(error.message),
            path: error.path,
        };
        if (onUnauthorizedError != null && onUnauthorizedError(processedError)) {
            return { unhandledErrors: [], handledErrors: [processedError] };
        }
        return { unhandledErrors: [processedError], handledErrors: [] };
    }
    if (((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.validationErrors) != null) {
        const processedError = {
            type: types_1.ApolloErrorType.INPUT_VALIDATION_ERROR,
            error: normalizeError(error),
            message: normalizeErrorMessage(error.message),
            path: error.path,
            invalidArgs: error.extensions.invalidArgs,
            violations: error.extensions.validationErrors,
        };
        if (onInputValidationError != null && onInputValidationError(processedError)) {
            return { unhandledErrors: [], handledErrors: [processedError] };
        }
        return { unhandledErrors: [processedError], handledErrors: [] };
    }
    const processedError = {
        type: ((_b = error.extensions) === null || _b === void 0 ? void 0 : _b.code) != null ? error.extensions.code : types_1.ApolloErrorType.SERVER_ERROR,
        error: normalizeError(error),
        message: translateErrorMessage('INTERNAL_SERVER_ERROR', translations !== null && translations !== void 0 ? translations : exports.defaultErrorMessageTranslations),
        path: error.path,
    };
    if (onServerError != null && onServerError(processedError)) {
        return { unhandledErrors: [], handledErrors: [processedError] };
    }
    return { unhandledErrors: [processedError], handledErrors: [] };
}
function processNetworkError(error, options = {}) {
    options = { ...defaultProcessorOptions, ...options };
    const { onNetworkError, translations } = options;
    let message = error.networkError != null && error.networkError.message != null
        ? normalizeErrorMessage(error.networkError.message)
        : normalizeErrorMessage(error.message);
    switch (message) {
        case 'Failed to fetch':
            message = translateErrorMessage('FAILED_TO_FETCH', translations !== null && translations !== void 0 ? translations : exports.defaultErrorMessageTranslations);
            break;
    }
    const processedError = {
        type: types_1.ApolloErrorType.NETWORK_ERROR,
        error,
        statusCode: error.networkError != null ? error.networkError.statusCode : undefined,
        message,
    };
    if (onNetworkError != null && onNetworkError(processedError)) {
        return { unhandledErrors: [], handledErrors: [processedError] };
    }
    return { unhandledErrors: [processedError], handledErrors: [processedError] };
}
function processApolloError(error, options = {}) {
    var _a, _b;
    options = { ...defaultProcessorOptions, ...options };
    const { onServerError } = options;
    if (error.graphQLErrors != null && error.graphQLErrors.length > 0) {
        const errorProcessorResults = error.graphQLErrors.map(graphQLError => processGraphQLError(graphQLError, options));
        return {
            unhandledErrors: errorProcessorResults.flatMap(result => result.unhandledErrors),
            handledErrors: errorProcessorResults.flatMap(result => result.handledErrors),
        };
    }
    if (((_b = (_a = error.networkError) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.errors) != null && error.networkError.result.errors.length > 0) {
        const errorProcessorResults = error.networkError.result.errors.map(graphQLError => processGraphQLError(graphQLError, options));
        return {
            unhandledErrors: errorProcessorResults.flatMap(result => result.unhandledErrors),
            handledErrors: errorProcessorResults.flatMap(result => result.handledErrors),
        };
    }
    if (error.networkError != null) {
        return processNetworkError(error, options);
    }
    const processedError = {
        type: types_1.ApolloErrorType.SERVER_ERROR,
        error,
        message: error.message,
    };
    if (onServerError != null && onServerError(processedError)) {
        return { unhandledErrors: [], handledErrors: [processedError] };
    }
    return { unhandledErrors: [processedError], handledErrors: [] };
}
exports.processApolloError = processApolloError;
//# sourceMappingURL=processApolloError.js.map